import { useState,useEffect } from "react";
import "../styles/addTournament.css";
import { API_CONFIG } from "../config/api";
import { generateAuthToken,generateURN } from "./hmac";


const AddTournament = () => {
  const [form, setForm] = useState({
    tournamentInfoId: "",
    tournamentName: "",
    date: "",
    info: "",
    link: "",
    tournamentStatus: 1,
    description: "",
    format: "",
    playerList: [],
    createdBy: "ADMIN",
  });

  const [playerName, setPlayerName] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");


  const fetchTournaments = async () => {
    try {
      const {host,fetchTournaments,basic}=API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      await fetch(
        `https://${host}${fetchTournaments.path}`,
        {
          method: fetchTournaments.method,
          credentials: "include",
          headers:{
             Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
             urn:urn,
             authToken:authToken,
           } 
        }
      );
    } catch (err) {
      setMsg("Failed to fetch tournaments: " + err.message);
    }
  };
  
  useEffect(() => {
    fetchTournaments();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]:
        name === "tournamentStatus" ? Number(value) : value,
    }));
  };

  const addPlayer = () => {
    if (!playerName.trim()) return;

    setForm((prev) => ({
      ...prev,
      playerList: [...prev.playerList, playerName.trim()],
    }));

    setPlayerName("");
  };

  const removePlayer = (index) => {
    setForm((prev) => ({
      ...prev,
      playerList: prev.playerList.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    // Basic validation
    if (!form.tournamentInfoId || !form.tournamentName || !form.date) {
      setMsg("Please fill tournamentInfoId, tournamentName and date.");
      return;
    }

    try {
      setLoading(true);
      const {host,addTournament,basic}=API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn,"admin");
      const res = await fetch(`https://${host}${addTournament.path}`, {
        method: addTournament.method,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization:`Basic ${basic.BASIC_AUTH_ADMIN}`,
          urn:urn,
          authToken:authToken,
          
        },
        body: JSON.stringify(form),
      });

      if (!res.ok ) {
        setMsg("Failed to add tournament.");
        return;
      }

      setMsg("Tournament added successfully!");
      sessionStorage.clear();
      await fetchTournaments();
      // Reset form
      setForm({
        tournamentInfoId: "",
        tournamentName: "",
        date: "",
        info: "",
        link: "",
        tournamentStatus: 1,
        description: "",
        format: "",
        playerList: [],
        createdBy: "ADMIN",
      });
      setPlayerName("");
    } catch (err) {
      setMsg("Something went wrong: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-tournament-container">
      <h2 className="add-tournament-title">Add Tournament</h2>

      <form className="add-tournament-form" onSubmit={handleSubmit}>
        {/* Tournament Info ID */}
        <div className="field">
          <label>Tournament Info Id</label>
          <input
            type="text"
            name="tournamentInfoId"
            value={form.tournamentInfoId}
            onChange={handleChange}
            placeholder="SRM_CHESS_2025_02"
          />
        </div>

        {/* Tournament Name */}
        <div className="field">
          <label>Tournament Name</label>
          <input
            type="text"
            name="tournamentName"
            value={form.tournamentName}
            onChange={handleChange}
            placeholder="SRM University Rapid Championship"
          />
        </div>

        {/* Date */}
        <div className="field">
          <label>Date</label>
          <input
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
          />
        </div>

        {/* Format */}
        <div className="field">
          <label>Format</label>
          <input
            type="text"
            name="format"
            value={form.format}
            onChange={handleChange}
            placeholder="Rapid / Blitz / Classical"
          />
        </div>

        {/* Tournament Status */}
        <div className="field">
          <label>Status</label>
          <select
            name="tournamentStatus"
            value={form.tournamentStatus}
            onChange={handleChange}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        {/* Info */}
        <div className="field">
          <label>Info</label>
          <textarea
            name="info"
            value={form.info}
            onChange={handleChange}
            placeholder="Rapid chess tournament open to all SRM students"
          />
        </div>

        {/* Description */}
        <div className="field">
          <label>Description</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            placeholder="Swiss system rapid tournament"
          />
        </div>

        {/* Link */}
        <div className="field">
          <label>Link</label>
          <input
            type="text"
            name="link"
            value={form.link}
            onChange={handleChange}
            placeholder="https://..."
          />
        </div>

        {/* Player List */}
        <div className="field">
          <label>Add Players (optional)</label>

          <div className="player-add-row">
            <input
              type="text"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              placeholder="Enter player name"
            />
            <button
              type="button"
              className="btn-secondary"
              onClick={addPlayer}
            >
              Add
            </button>
          </div>

          {form.playerList.length > 0 && (
            <div className="player-list">
              {form.playerList.map((p, idx) => (
                <div className="player-pill" key={idx}>
                  <span>{p}</span>
                  <button type="button" onClick={() => removePlayer(idx)}>
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Submit */}
        <button className="btn-primary" disabled={loading} type="submit">
          {loading ? "Adding..." : "Add Tournament"}
        </button>

        {msg && <p className="form-msg">{msg}</p>}
      </form>
    </div>
  );
};

export default AddTournament;
